exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-70c2d283] {\n  border-collapse: collapse;\n  margin-bottom: 0;\n}\n.order-info-cards > div[data-v-70c2d283] {\n  flex: 1 1 20%;\n  margin-right: 15px;\n}\n.order-info-cards > div[data-v-70c2d283]:last-of-type {\n    margin-right: 0;\n}\n.items-table[data-v-70c2d283] {\n  overflow-y: auto;\n  max-height: 350px;\n}\n.order-notes-card[data-v-70c2d283] {\n  flex: 2 1 640px !important;\n}\n", ""]);

// exports
